'use strict';
export class Message {
  constructor(data = null){
    this.origin = ''
    this.types = ["text"]
    this.emojis = []
    this.mentions = []
    this.URLs = []
    this.files = []
    if(data != null){
      if(typeof data.origin != 'undefined'){
        this.origin = data.origin;
      }
      if(typeof data.types != 'undefined'){
        this.types = data.types;
      }
      if(typeof data.emojis != 'undefined'){
        this.emojis = data.emojis;
      }
      if(typeof data.mentions != 'undefined'){
        this.mentions = data.mentions;
      }
      if(typeof data.URLs != 'undefined'){
        this.URLs = data.URLs;
      }
    }
  }
   addType(type){
    this.types.push(type)
  }
   addEmoji(emo){
    this.emojis.push(emo)
  }
   addURL(arrURL){
    this.URLs =  arrURL
  }
   addMention(arrMentions){
    this.mentions = arrMentions
  }
  addFiles(arrFiles){
    this.files = arrFiles
  }
  setOrigin(origin){
    this.origin = origin
    this.origin.replace("&nbsp;", "")
  }
}
